import React from 'react';

type TwoLineHeaderProps = {
  line1: string;
  line2: string;
  boldSuffixLength?: number;
};

export const TwoLineHeader: React.FC<TwoLineHeaderProps> = ({
  line1,
  line2,
  boldSuffixLength = 0,
}) => {
  const plainPart =
    boldSuffixLength > 0 ? line2.slice(0, -boldSuffixLength) : line2;
  const boldPart = boldSuffixLength > 0 ? line2.slice(-boldSuffixLength) : null;
  return (
    <span className="block leading-tight text-gray-900">
      <span className="block">{line1}</span>
      <span className="block">
        {plainPart}
        {boldPart != null && (
          <>
            <strong className="font-bold underline">{boldPart}</strong>
            <span className="text-gray-900">)</span>
          </>
        )}
      </span>
    </span>
  );
};
